import _Promise from "babel-runtime/core-js/promise";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";

var IndexDB = function () {
  function IndexDB(name, version) {
    _classCallCheck(this, IndexDB);

    this.dbName = name || "kscs";
    this.tableName = "SYS_DATA";
    this.version = version || 1;
    this.database = null;
  }

  _createClass(IndexDB, [{
    key: "open",
    value: function open() {
      var that = this;
      return new _Promise(function (resolve, reject) {
        var request = window.indexedDB.open(that.dbName, that.version);
        request.onerror = function (event) {
          reject("indexDb连接打开失败");
        };
        request.onsuccess = function (event) {
          that.database = event.target.result;
          resolve(event.target.result);
        };
        request.onupgradeneeded = function (event) {
          that.database = event.target.result;
          if (!that.database.objectStoreNames.contains(that.tableName)) {
            that.database.createObjectStore(that.tableName);
          }
        };
      });
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var that = this;
      return new _Promise(function (resolve, reject) {
        that.get(key).then(function (res) {
          var db = that.database.transaction([that.tableName], "readwrite").objectStore(that.tableName);
          var request = res ? db.put(value, key) : db.add(value, key);
          request.onsuccess = function (event) {
            resolve(true);
          };
          request.onerror = function (event) {
            reject("数据保存失败");
          };
        }).catch(function () {
          reject("数据保存失败");
        });
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      var that = this;
      return new _Promise(function (resolve, reject) {
        var request = that.database.transaction([that.tableName]).objectStore(that.tableName).get(key);
        request.onerror = function (event) {
          reject("读取失败");
        };
        request.onsuccess = function (event) {
          var result = request.result;
          if (result) {
            resolve(result);
          } else {
            resolve(undefined);
          }
        };
      });
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var that = this;
      return new _Promise(function (resolve, reject) {
        var request = that.database.transaction([that.tableName], "readwrite").objectStore(that.tableName).delete(key);
        request.onsuccess = function (event) {
          resolve("删除数据成功");
        };
        request.onerror = function (event) {
          reject("删除数据失败");
        };
      });
    }
  }]);

  return IndexDB;
}();

export default {
  getInstance: function getInstance() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new IndexDB(args);
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/indexdb.js
// module id = 1614
// module chunks = 2